<div>
    <a href="/#/home">home</a>
</div>